export default {
  name: "VirtualClass",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M27 3H5c-1.16 0-2 .84-2 2v22c0 1.16.84 2 2 2h22c1.16 0 2-.84 2-2V5c0-1.16-.84-2-2-2zM5 5h22v4H5V5zm0 22V11h22v16H5zM19 7c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm3 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm3 0c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zm-4.79 10.09-5.36-2.38c-.59-.3-1.3-.25-1.89.11-.6.37-.96 1-.96 1.68v5.7c0 .78.45 1.49 1.15 1.82a1.873 1.873 0 0 0 1.92-.19l5.42-3.21a2.1 2.1 0 0 0 .88-1.93c-.08-.73-.52-1.33-1.16-1.6zM14 22.13l-.01-5.62 5.38 2.38.01.05L14 22.13z",
  },
}
